(() => {
  const defaults = {
    toggle: '.js-header-toggle',
    menuClose: '.js-header-menu-close',
    menuOverlay: '.js-header-menu-overlay',
    toggle: '.js-header-toggle',
    menuClose: '.js-header-menu-close',
    menu: '.js-header-menu',
    subMenu: '.js-sub-menu',
    menuItem: '.js-menu-item',
    menuLink: '.js-menu-item-link',
    menuSubLink: '.js-menu-sub-item-link',
    megaOverlay: '.js-menu__sub-overlay',
    menuActive: 'header__menu--active',
    menuItemActive: 'menu__item--active',
    menuLinkActive: 'menu__item-link--active',
    subMenuLinkActive: 'menu__sub-item-link--active',
    subMenuListActive: 'menu__sub-drop-list--active',
    megaMenuClass: 'menu__sub--mega',
  };

  class Menu extends HTMLElement {
    constructor(options) {
      super();

      this.currentMenu = `[data-menu-id="${this.dataset.menuId}"]`;
      this.options = { ...defaults, ...options };

      if (!this.options) return;

      this.toggle = qs(this.options.toggle);
      this.toggleClose = qsa([
        this.options.menuClose,
        this.options.menuOverlay,
      ]);
      this.menu = qsa(`${this.currentMenu} ${this.options.menu}`);
      this.menuItems = qsa(this.options.menuItem);
      this.menuLinks = qsa(`${this.currentMenu} ${this.options.menuLink}`);
      this.menuSubLinks = qsa(`${this.currentMenu} ${this.options.menuSubLink}`);
      this.menuActive = this.options.menuActive;
      this.menuItemActive = this.options.menuItemActive;
      this.menuLinkActive = this.options.menuLinkActive;
      this.subMenuLinkActive = this.options.subMenuLinkActive;
      this.subMenuListActive = this.options.subMenuListActive;
      this.megaMenuClass = this.options.megaMenuClass;
      this.megaOverlay = qsa(this.options.megaOverlay);
      this.lockedClass = document.documentElement.classList.contains('html--locked');

      this.init();
    }

    init() {
      this.toggleFunc();
      this.subMenuFunc();
      this.megaMenuDropownFunc();

      document.addEventListener('click', () => {
        if (isDesktop()) {
          this.hideActiveSubMenu();
          if(document.querySelector('html').classList.contains('html--locked')) {
            scrollLock(false);
          }
        }
      });
    }

    subMenuFunc() {
      this.menuLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const target = e.currentTarget;
          const menuItem = getClosest(this.options.menuItem, target);
          const subMenu = qs(
            this.options.subMenu,
            getClosest(this.options.menuItem, target)
          );

          subMenu.addEventListener('click', (sub) => sub.stopPropagation());

          if(menuItem.classList.contains(this.menuItemActive)) {
            menuItem.classList.remove(this.menuItemActive);

            if (isDesktop()) {
              scrollLock(false);
              if (!subMenu.classList.contains(this.megaMenuClass)) {
                this.removeSubMenuActiveClass();
              }
            } else {
              subMenu.style.maxHeight = 0;
              this.removeSubMenuActiveClass();
            }
          } else {
            isDesktop() && scrollLock();
            this.menuItems.forEach(el => {
              el.classList.remove(this.menuItemActive);
            })
            menuItem.classList.add(this.menuItemActive);
            this.removeSubMenuActiveClass();

            if(!isDesktop()) {
              qsa(this.options.subMenu).forEach(sub => {
                sub.style.maxHeight = 0;
              })
              const subParentHeight = subMenu.scrollHeight;
              subMenu.style.maxHeight = `${subParentHeight}px`;
            }
          }
        })
      });
    }

    megaMenuDropownFunc() {
      if (this.menuSubLinks) {
        this.menuSubLinks.forEach((sub) => {
          sub.addEventListener('click', (e) => {
            e.preventDefault();
            const target = e.currentTarget;
            const subMenu = qs(
              this.options.subMenu,
              getClosest('.js-menu-drop', target)
            );
            const currentMenuItem = qs(
              '.js-menu-item.menu__item--active > .js-sub-menu'
            );
            const subHeight = qs('.js-menu-sub-inner', subMenu).clientHeight;
            let subChildrenHeight = 0;

            if (target.classList.contains(this.subMenuLinkActive)) {
              target.classList.remove(this.subMenuLinkActive);
              subMenu.classList.remove(this.subMenuListActive);
              subMenu.style.maxHeight = 0;
              if (!isDesktop()) {
                currentMenuItem.style.maxHeight = `${
                  currentMenuItem.scrollHeight - subHeight
                }px`;
              }
            } else {
              this.removeSubMenuActiveClass();
              target.classList.add(this.subMenuLinkActive);
              subMenu.classList.add(this.subMenuListActive);
              subMenu.style.maxHeight = `${subHeight}px`;
              if (!isDesktop()) {
                subChildrenHeight += subHeight;
                currentMenuItem.style.maxHeight = `${
                  subChildrenHeight + currentMenuItem.scrollHeight
                }px`;
              }
            }
          });
        });
      }

      if(this.menuItems && isDesktop()) {
        this.menuItems.forEach(item => {
          item.addEventListener('mouseenter', (e) => {
            e.currentTarget.classList.add(this.menuItemActive);
          })
          item.addEventListener('mouseleave', (e) => {
            e.currentTarget.classList.remove(this.menuItemActive);
          })
        })
      }

      if(this.megaOverlay && isDesktop()) {
        this.megaOverlay.forEach(el => {
          el.addEventListener('mouseenter', (e) => {
            getClosest('.menu__item--with-sub', e.currentTarget).classList.remove(this.menuItemActive);
          })
        })
      }
    }

    toggleFunc() {
      this.toggle.addEventListener('click', (e) => {
        e.preventDefault();
        this.menu.forEach(nav => {
          nav.classList.add(this.menuActive);
        })
        e.currentTarget.classList.add('is-hidden');
        scrollLock();
      });

      this.toggleClose.forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggle.classList.remove('is-hidden');
          this.menu.forEach(nav => {
            nav.classList.remove(this.menuActive);
          })
          this.menuItems.forEach((item) => {
            item.classList.remove(this.menuItemActive);
          });
          const subs = qsa(this.options.subMenu);
          subs && subs.forEach(sub => {
            sub.style.maxHeight = 0;
          })
          this.removeSubMenuActiveClass();
          if(document.querySelector('html').classList.contains('html--locked')) {
            scrollLock(false);
          }
        });
      });
    }

    removeMenuActiveClass(e) {
      const item = getClosest(this.options.menuItem, e);
      item.classList.remove(this.menuItemActive);
      this.removeSubMenuActiveClass();
    }

    removeSubMenuActiveClass() {
      if (this.menuSubLinks) {
        this.menuSubLinks.forEach((el) => {
          const subChildMenu = qs(
           this.options.subMenu,
            getClosest('.js-menu-drop', el)
          );
          el.classList.remove(this.subMenuLinkActive);
          subChildMenu.classList.remove(this.subMenuListActive);
          subChildMenu.style.maxHeight = 0;
        });
      }
    }

    hideActiveSubMenu() {
      const currentItemActive = qs('.js-menu-item.menu__item--active');
      if (currentItemActive) {
        currentItemActive.classList.remove(this.menuItemActive);
        const lockedClass =
          document.documentElement.classList.contains('html--locked');
        if (this.lockedClass) scrollLock(false);
      }
    }
  }

  customElements.define('main-menu', Menu);

  new Selector({
    id: '#language-selector-mobile',
    onChange: (e) => console.log(e),
  });
  new Selector({ id: '#country-selector-mobile' });
  new Selector({ id: '#currency-selector-mobile' });
})();
